import React, { Suspense, lazy, useState, useEffect } from "react";
import "./css/App.css";

const sectionMap: Record<string, React.LazyExoticComponent<React.FC>> = {
  'om meg': lazy(() => import("./sections/About")),
  kompetanse: lazy(() => import("./sections/Skills")),
  jobberfaring: lazy(() => import("./sections/Experience")),
  prosjekter: lazy(() => import("./sections/Projects")),
  sertifiseringer: lazy(() => import("./sections/Certifications")),
  kontakt: lazy(() => import("./sections/Contact")),
};

export default function App() {
  const [section, setSection] = useState<string>("om meg");
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const SectionComponent = sectionMap[section];

  useEffect(() => {
    document.title = `CV - Cristhian Gertner - ${section.charAt(0).toUpperCase() + section.slice(1)}`;

    // Set favicon
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = 'assets/favicon.ico';
    link.type = 'image/x-icon';
    document.head.appendChild(link);

     // Cleanup function
    return () => {
      document.head.removeChild(link);
    };
    
  }, [section]);

  const handleSelect = (key: string) => {
    setSection(key);
    setMenuOpen(false); // auto-close sidebar on mobile
  };

  return (
    <div className="app-container">
      <button
        className="burger-button"
        onClick={() => setMenuOpen((prev) => !prev)}
        aria-label="Toggle menu"
      >
        ☰
      </button>

      <nav className={`sidebar ${menuOpen ? "open" : ""}`}>
        {Object.keys(sectionMap).map((key) => (
          <button
            key={key}
            className={`menu-btn ${section === key ? "active" : ""}`}
            onClick={() => handleSelect(key)}
          >
            {key.charAt(0).toUpperCase() + key.slice(1)}
          </button>
        ))}
        <div style={{ textAlign: 'left', fontSize: '1rem'}}>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg"
          alt="Built with React"
          style={{ height: '40px' }}
        />&nbsp;Built with React
        </div>        

<div style={{ textAlign: 'left', fontSize: '1rem', display: 'flex', alignItems: 'center' }}>
    Contributions by&nbsp;
    <img
      src="https://upload.wikimedia.org/wikipedia/commons/8/8a/Google_Gemini_logo.svg"
      alt="Gemini AI contributed"
      style={{ height: '20px', verticalAlign: 'middle', transform: 'translateY(-2px)' }} // dirty hack on the transform since the svg-file actually has some built in paddings...
    />
</div>
        
      
      </nav>

      <main className="content">
        <Suspense fallback={<div>Loading section...</div>}>
          {SectionComponent && <SectionComponent />}
        </Suspense>
      </main>
    </div>
  );
}
